import {
  Box,
  Field,
  FilterTableWithQueryParams,
  Grid,
  TextField,
} from "components";
import Select from "components/common/Select";
import { compose, withHooks, withTranslation } from "enhancers";
import { gql, paths } from "utils/helper";

export const budgetFilterInitialValues = {
  code: "",
  fullName: "",
  year: "all",
};

const BudgetFilters = ({ t, yearlyRequestOptions }: any) => (
  <FilterTableWithQueryParams
    initialValues={budgetFilterInitialValues}
    path={paths.budgetPath}
  >
    <Box display="flex" flexDirection="column">
      <Grid container spacing={6} mt={6}>
        <Grid item xs={4}>
          <Field
            component={TextField}
            name="code"
            type="text"
            label={t(".filter.code")}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <Field
            component={TextField}
            name="fullName"
            type="text"
            label={t(".filter.fullName")}
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <Field
            component={Select}
            name="year"
            type="text"
            label={t(".filter.yearlyRequest")}
            options={yearlyRequestOptions}
            fullWidth
            disableClearable
          />
        </Grid>
      </Grid>
    </Box>
  </FilterTableWithQueryParams>
);

export const API = {
  FETCH_OPTIONS: gql`
    query FETCH_OPTIONS {
      getYearlyBudgetOption {
        label
        value
      }
    }
  `,
};

const enhancer = compose(
  withTranslation({
    prefix: "pages.main.budget.index",
  }),
  withHooks((props: any, hooks: any) => {
    const { t } = props;
    const { useMemo, useQuery } = hooks;

    const { data: options } = useQuery(API.FETCH_OPTIONS, {
      fetchPolicy: "network-only",
    });

    const yearlyRequestOptions = useMemo(
      () =>
        [{ label: t(".filter.allYears"), value: "all" }].concat(
          options?.getYearlyBudgetOption || []
        ),
      [options, t]
    );

    return { yearlyRequestOptions };
  })
);

export default enhancer(BudgetFilters);
